export default __webpack_public_path__ + "static/media/Ripple.d3cf413a.gif";